<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="49.246"
    height="58.191"
    viewBox="0 0 49.246 58.191"
  >
    <g
      id="ico_backup_3"
      data-name="ico_backup 3"
      transform="translate(-196.532 78.67)"
    >
      <path
        id="Path_164"
        data-name="Path 164"
        d="M236.308-36.15a2.2,2.2,0,0,0-2.2,2.2v5.76a3.319,3.319,0,0,1-3.316,3.315H204.244a3.319,3.319,0,0,1-3.315-3.315V-70.958a3.319,3.319,0,0,1,3.315-3.315h26.549a3.319,3.319,0,0,1,3.316,3.315v5.76a2.2,2.2,0,0,0,2.2,2.2,2.2,2.2,0,0,0,2.2-2.2v-5.76a7.722,7.722,0,0,0-7.713-7.712H204.244a7.721,7.721,0,0,0-7.712,7.712v42.766a7.721,7.721,0,0,0,7.712,7.712h26.549a7.722,7.722,0,0,0,7.713-7.712v-5.76A2.2,2.2,0,0,0,236.308-36.15Z"
        transform="translate(0 0)"
        fill="#dadada"
      />
      <path
        id="Path_165"
        data-name="Path 165"
        d="M245.623-49.037h-17.7v-5.357a1.577,1.577,0,0,0-.8-1.406,1.33,1.33,0,0,0-1.379.062l-11.57,7.553a1.592,1.592,0,0,0-.7,1.348,1.591,1.591,0,0,0,.7,1.347l11.568,7.553a1.343,1.343,0,0,0,.739.225,1.338,1.338,0,0,0,.638-.164,1.585,1.585,0,0,0,.806-1.411V-44.64h17.7a2.2,2.2,0,0,0,2.2-2.2A2.2,2.2,0,0,0,245.623-49.037Z"
        transform="translate(-2.043 -2.738)"
        fill="#dadada"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'InsertIcon'
}
</script>

<style></style>
